const anonymousAvatarSeed = 'iden-user';
/** Pick a stable, non-empty identity value for deterministic generated avatars. */
export const resolveDefaultAvatarSeed = (...candidates) => candidates.find((candidate) => Boolean(candidate?.trim()))?.trim() ??
    anonymousAvatarSeed;
